export default __webpack_public_path__ + "static/media/arrow.b6d6d067.svg";